module.exports = __webpack_public_path__ + "media/promo/lum2021/images/4th-5f79cc368cb1e020824978d6568153a2.jpg";